export const QRCODE = 'QRCODE'
export const AS_URI = 'AS_URI'
export const COPYPASTE = 'COPYPASTE'
